import { Link } from "react-router-dom";
import styled from "styled-components";

export const GraphicsItem = styled(Link)`
  font-family: Kodchasan, serif;
  color: white;
  background: rgb(22, 22, 24, 0.4);
  width: fit-content;
  padding: 24px;
  flex-direction: column;
  display: flex;
  align-items: center;
  transition: 260ms;
  text-decoration: none;
  margin: 33px;
  font-size: 22px;
  border-radius: 10px;
  height: fit-content;
  box-shadow: 0px 8px 20px -5px rgba(255, 0, 0, 0.1);
  :hover {
    background: rgb(22, 22, 24);;
    box-shadow: 0px 8px 20px -5px rgba(255, 0, 0, 0.4);
    font-size: 25px;
    border-radius: 20px;
    text-shadow: 0px 5px 6px rgba(255, 0, 0, 0.4);
  }
`;

export const GraphicsList = styled.div`
  margin: 24px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const GraphicsImg = styled.img`
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.4);
  transition: 260ms;
  padding: 5px;
  border-radius: 20px;
  @media screen and (min-width: 720px) {
    width: 500px;
    ${GraphicsItem}:hover & {
      box-shadow: 0px 8px 18px -5px rgba(79, 192, 255, 0.2);
      filter: brightness(150%);
      width: 520px;
    }
  
  }
`;

export const GraphicsBox = styled.div`
  margin-top: 18px;
  transition: 0.4s ease 0s;
  `;


export const GraphicsItems = styled.div`
flex-direction: column;
display: flex;
flex-wrap: wrap;
align-items: center;
width: 1000px;
`;